exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-salarie[data-v-8600425e]{height:100%;display:-ms-flexbox;display:flex}.section-salarie>.left[data-v-8600425e]{width:120px;min-width:120px;margin-right:15px;overflow:hidden}.section-salarie>.right[data-v-8600425e]{width:calc(100% - 135px)}.section-salarie>.right .top[data-v-8600425e]{width:100%;min-width:100%;height:152px;margin-bottom:15px;margin-right:15px}.section-salarie>.right .bottom[data-v-8600425e]{height:calc(100% - 167px);width:100%}.section-salarie>.right .bottom .tab-content[data-v-8600425e]{height:100%}.section-salarie>.right .bottom .tab-content .nav-item[data-v-8600425e]{display:none}.section-salarie>.right .bottom .tab-content .nav-item.active[data-v-8600425e]{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-8600425e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/ficheSalarie/salarie.scss
// module id = ggIE
// module chunks = 2